import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  GET,
  PATCH,
  Params,
  Query,
} from '@app/core/api';

import {NotificationCustomReadDto} from './dto/notification-custom-read.dto';
import {NotificationReadAllDto} from './dto/notification-read-all.dto';
import type {
  AllNotificationsResult,
  NotificationDetailQuery,
  NotificationInfoResult,
  NotificationListQuery,
} from './notification-api.models';

@ApiController('api/app/notification')
@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET('/all')
  getAllNotifications(
    @Query() params: NotificationListQuery,
  ): Observable<ApiResponse<AllNotificationsResult>> {
    return {} as Observable<ApiResponse<AllNotificationsResult>>;
  }

  @GET('/:id')
  getNotification(
    @Params('id') id: number,
    @Query() query: NotificationDetailQuery,
  ): Observable<ApiResponse<NotificationInfoResult>> {
    return {} as Observable<ApiResponse<NotificationInfoResult>>;
  }

  @PATCH('/read/all')
  markAllNotificationsRead(
    @Body() dto: NotificationReadAllDto,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  /** Bulk mark custom notifications only - does not affect system. */
  @PATCH('/custom/read')
  markCustomNotificationsAsRead(
    @Body() dto: NotificationCustomReadDto,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }
}
